<template>
  <div class="box">
    <tab-list-header
      v-if="!isFloatCurrency"
      class="tab"
      :cur-index="currentIndex"
      :list="tabList"
      :font-scale="false"
      @clickTab="changeTag"
    />
    <component
      :is="listName"
      :fund-code="fundCode"
      :element-data="elementData"
      :merge-data="mergeData"
      :trade-data="tradeData"
      :index-info="indexInfo"
    />
  </div>
</template>

<script>
import TabListHeader from './TabListHeader.vue';
import HistoryNetList from './HistoryNetList.vue';
import StageRiseList from './StageRiseList.vue';

export default {
  components: { HistoryNetList, StageRiseList, TabListHeader },

  props: {
    fundCode: String, // 基金代码
    elementData: Object, // 数据
    anchorIndex: Number, // 锚点索引
    mergeData: Object, // 聚合数据
    indexInfo: {
      default: () => {},
      type: Object,
    },
    tradeData: Array,

  },

  data() {
    return {
      currentIndex: 0, // 当前选中的tab
    };
  },

  computed: {
    tabList() {
      return [
        { tabName: '阶段涨幅', tabValue: 0 },
        { tabName: this.mergeData?.isShowFundSize ? '历史净值与规模' : '历史净值', tabValue: 1 },
      ];
    },
    isFloatCurrency() {
      return this.elementData?.isFloatCurrency;
    },
    // 列表名称
    listName() {
      if (this.isFloatCurrency) {
        return 'HistoryNetList';
      }
      const { currentIndex } = this;
      return ['StageRiseList', 'HistoryNetList'][currentIndex];
    },
  },

  methods: {
    // 切换tab
    changeTag(index) {
      const reportArr = [
        'wxgdpzy.sy.jdzf.click',
        'wxgdpzy.sy.lsjz.click',
      ];
      if (!(index === 1 && this.mergeData?.isShowFundSize)) {
        this.$wxSendTrack(reportArr[index], 'Click', { infoCode: this.fundCode, infoCodeType: 5 });
      }
      if (index !== this.currentIndex) {
        this.currentIndex = index;
      }
    },
  },
};
</script>

<style scoped>
.box {
  margin-top: 24px;
  border-radius: 16px;
  background-color: #ffffff;
}

.tab {
  padding-top: 16px;
  background-color: #ffffff;
}
</style>
